import React, { createContext, useContext, useState, useEffect } from 'react';

const PlacementAuthContext = createContext(null);

export function PlacementAuthProvider({ children }) {
  const [student, setStudent] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored auth on mount
    const storedToken = localStorage.getItem('placement_token');
    const storedStudent = localStorage.getItem('placement_student');
    
    if (storedToken && storedStudent) {
      setToken(storedToken);
      try {
        setStudent(JSON.parse(storedStudent));
      } catch (e) {
        console.error('Failed to parse stored student:', e);
        localStorage.removeItem('placement_token');
        localStorage.removeItem('placement_student');
      }
    }
    setLoading(false);
  }, []);

  const login = (tokenValue, studentData) => {
    setToken(tokenValue);
    setStudent(studentData);
    localStorage.setItem('placement_token', tokenValue);
    localStorage.setItem('placement_student', JSON.stringify(studentData));
  };

  const logout = () => {
    setToken(null);
    setStudent(null);
    localStorage.removeItem('placement_token');
    localStorage.removeItem('placement_student');
  };

  const updateStudent = (updatedData) => {
    const newStudent = { ...student, ...updatedData };
    setStudent(newStudent);
    localStorage.setItem('placement_student', JSON.stringify(newStudent));
  };

  return (
    <PlacementAuthContext.Provider 
      value={{ 
        student, 
        token, 
        loading, 
        isAuthenticated: !!token, 
        login, 
        logout,
        updateStudent
      }}
    >
      {children}
    </PlacementAuthContext.Provider>
  );
}

export function usePlacementAuth() {
  const context = useContext(PlacementAuthContext);
  if (!context) {
    throw new Error('usePlacementAuth must be used within a PlacementAuthProvider');
  }
  return context;
}
